import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { crearUsuario, listarEspecialidades, crearEspecialidad } from "../api";
import "./NuevoUsuarioView.css";

export default function NuevoUsuarioView() {
  const navigate = useNavigate();

  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [dni, setDni] = useState("");
  const [colegiado, setColegiado] = useState("");
  const [password, setPassword] = useState("");

  // ✅ role solo para permisos
  const [role, setRole] = useState("profesional"); // profesional | admin

  // 🔢 porcentaje profesional (0–100)
  const [porcentajeProfesional, setPorcentajeProfesional] = useState(70);

  // ✅ especialidades dinámicas
  const [especialidades, setEspecialidades] = useState([]);
  const [especialidadId, setEspecialidadId] = useState(""); // id seleccionado

  // ✅ crear especialidad "inline"
  const [nuevaEspecialidad, setNuevaEspecialidad] = useState("");
  const [creandoEspecialidad, setCreandoEspecialidad] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [okMsg, setOkMsg] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const data = await listarEspecialidades();
        setEspecialidades(data);
        if (data?.length) setEspecialidadId(String(data[0].id));
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  const crearNuevaEspecialidad = async () => {
    const nombre = nuevaEspecialidad.trim();
    if (!nombre) return;

    try {
      setCreandoEspecialidad(true);
      setError("");
      const creada = await crearEspecialidad({ nombre });
      setEspecialidades((prev) => [...prev, creada]);
      setEspecialidadId(String(creada.id));
      setNuevaEspecialidad("");
    } catch (err) {
      setError(err.message || "Error al crear especialidad");
    } finally {
      setCreandoEspecialidad(false);
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setOkMsg("");

    if (!nombre.trim() || !email.trim() || !password.trim()) {
      setError("Nombre, email y contraseña son obligatorios.");
      return;
    }

    if (role === "profesional" && !especialidadId) {
      setError("Selecciona (o crea) una especialidad.");
      return;
    }

    const p = Number(porcentajeProfesional);
    if (Number.isNaN(p) || p <= 0 || p >= 100) {
      setError("El porcentaje profesional debe estar entre 1 y 99.");
      return;
    }

    try {
      setLoading(true);

      await crearUsuario({
        nombre,
        email,
        password,
        dni,
        colegiado,
        role,
        porcentaje_profesional: p,

        // ✅ MODIFICACIÓN: antes especialidad_id, ahora specialty_id
        specialty_id: role === "profesional" ? Number(especialidadId) : null,
      });

      setOkMsg("✅ Usuario creado correctamente");

      setNombre("");
      setEmail("");
      setPassword("");
      setDni("");
      setColegiado("");
      setRole("profesional");
      setPorcentajeProfesional(70);
      setEspecialidadId(especialidades?.length ? String(especialidades[0].id) : "");
    } catch (err) {
      setError(err.message || "Error al crear usuario");
    } finally {
      setLoading(false);
    }
  };

  const pProf = Number(porcentajeProfesional) || 0;
  const pCentro = pProf > 0 && pProf < 100 ? 100 - pProf : "";

  return (
    <div className="nuevo-user-wrapper">
      <div className="nuevo-user-card">
        <div className="nuevo-user-header">
          <h2>
            <i className="fa-solid fa-user-plus"></i> Crear nuevo usuario
          </h2>

          <button className="btn-volver" onClick={() => navigate(-1)}>
            ← Volver
          </button>
        </div>

        <form className="nuevo-user-form" onSubmit={onSubmit}>
          <div className="form-group">
            <label>Nombre completo</label>
            <input
              type="text"
              value={nombre}
              placeholder="Nombre y apellidos"
              onChange={(e) => setNombre(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Email *</label>
            <input
              type="email"
              value={email}
              placeholder="correo@ejemplo.com"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>DNI</label>
            <input
              type="text"
              value={dni}
              placeholder="12345678X"
              onChange={(e) => setDni(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Nº Colegiado</label>
            <input
              type="text"
              value={colegiado}
              placeholder="Ej: AN-12345"
              onChange={(e) => setColegiado(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Contraseña *</label>
            <input
              type="password"
              value={password}
              placeholder="Contraseña inicial"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Tipo de usuario *</label>
            <select value={role} onChange={(e) => setRole(e.target.value)}>
              <option value="profesional">Profesional</option>
              <option value="admin">Administrador</option>
            </select>
          </div>

          {role === "profesional" && (
            <div className="form-group">
              <label>Especialidad *</label>

              <select
                value={especialidadId}
                onChange={(e) => setEspecialidadId(e.target.value)}
              >
                <option value="">— Selecciona una especialidad —</option>
                {especialidades.map((esp) => (
                  <option key={esp.id} value={esp.id}>
                    {esp.nombre}
                  </option>
                ))}
              </select>

              <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                <input
                  type="text"
                  value={nuevaEspecialidad}
                  placeholder="Crear nueva (ej: Psicología adultos)"
                  onChange={(e) => setNuevaEspecialidad(e.target.value)}
                />
                <button
                  type="button"
                  className="btn-secundario"
                  onClick={crearNuevaEspecialidad}
                  disabled={creandoEspecialidad || !nuevaEspecialidad.trim()}
                >
                  {creandoEspecialidad ? "Creando..." : "Añadir"}
                </button>
              </div>

              <small className="help-text">
                El profesional solo verá pacientes de su especialidad.
              </small>
            </div>
          )}

          <div className="form-group">
            <label>Porcentaje profesional (%)</label>
            <input
              type="number"
              min="1"
              max="99"
              value={porcentajeProfesional}
              onChange={(e) => setPorcentajeProfesional(e.target.value)}
            />
            <small className="help-text">
              El centro se queda el resto:&nbsp;
              {pCentro !== "" ? <strong>{pCentro}%</strong> : "—"}
            </small>
          </div>

          {error && <p className="form-error">{error}</p>}
          {okMsg && <p className="form-ok">{okMsg}</p>}

          <button className="btn-crear" type="submit" disabled={loading}>
            {loading ? "Creando..." : "Crear usuario"}
          </button>
        </form>
      </div>
    </div>
  );
}
